export default "__VITE_ASSET__C5Sh63r4__"